import { useMemo, useState } from "react";

const frequencyOptions = [
  { label: "Weekly", value: 52 },
  { label: "Biweekly", value: 26 },
  { label: "Semi-monthly", value: 24 },
  { label: "Monthly", value: 12 },
];

export default function W4Estimator() {
  const [frequency, setFrequency] = useState(26);
  const [gross, setGross] = useState(1200);
  const [status, setStatus] = useState("single");
  const [dependents, setDependents] = useState(0);
  const [otherIncome, setOtherIncome] = useState(0);

  const standardDeduction = status === "married" ? 27700 / frequency : 13850 / frequency;
  const incomePerPeriod = (Number(gross) || 0) + (Number(otherIncome) || 0);
  const taxable = Math.max(incomePerPeriod - standardDeduction - dependents * 4300 / frequency, 0);
  const estimatedWithholding = taxable * 0.12;

  const explanation = useMemo(() => {
    if (!incomePerPeriod) return "Enter your pay and filing status to estimate withholding.";
    return `This is a simple federal estimate. More dependents or credits lower withholding, while higher gross pay raises it. Adjust extra withholding if you want a bigger refund or smaller take-home pay.`;
  }, [incomePerPeriod]);

  return (
    <main style={{ padding: "120px 0 80px" }}>
      <div className="container">
        <h1 style={{ fontFamily: "Fraunces, serif", fontSize: 40, marginBottom: 8 }}>W-4 Withholding Estimator</h1>
        <p style={{ color: "var(--t2)", marginBottom: 20 }}>Estimate federal withholding per pay period using a simplified allowance method.</p>

        <div className="card-base" style={{ padding: 18, marginBottom: 18 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Pay frequency</div>
              <select className="input" value={frequency} onChange={(e) => setFrequency(e.target.value)}>
                {frequencyOptions.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </label>

            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Gross pay per period</div>
              <input className="input" type="number" value={gross} onChange={(e) => setGross(e.target.value)} />
            </label>

            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Filing status</div>
              <select className="input" value={status} onChange={(e) => setStatus(e.target.value)}>
                <option value="single">Single</option>
                <option value="married">Married</option>
              </select>
            </label>

            <label>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Dependents / credits</div>
              <input className="input" type="number" value={dependents} onChange={(e) => setDependents(e.target.value)} />
            </label>

            <label style={{ gridColumn: "1 / -1" }}>
              <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 6 }}>Other income per period</div>
              <input className="input" type="number" value={otherIncome} onChange={(e) => setOtherIncome(e.target.value)} />
            </label>
          </div>
        </div>

        <div className="card-base" style={{ padding: 18 }}>
          <div className="font-mono" style={{ fontSize: 11, color: "var(--t3)", marginBottom: 8 }}>Estimated federal withholding</div>
          <div style={{ fontFamily: "Fraunces, serif", fontSize: 28 }}>${estimatedWithholding.toFixed(2)}</div>
          <div style={{ color: "var(--t2)", marginTop: 8 }}>{explanation}</div>
          <div style={{ color: "var(--t3)", marginTop: 10, fontSize: 12 }}>This is an estimate, not financial or tax advice.</div>
        </div>
      </div>
    </main>
  );
}
